import useHelpers from "../../../helpers";

const useRolesSelectors = () => {
  // Helpers
  const { useCreateSelector } = useHelpers();
  const { createSelector } = useCreateSelector();

  const roleSelected = createSelector(
    state => state.roleSelected,
    roleSelected => roleSelected
  );

  return {
    roleSelected
  };
};

export default useRolesSelectors;
